import React from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const AnalyticsChart = ({ graphData=[], graphType='spline' }) => {
    const options = {
        chart:{
            height: 150,
            backgroundColor: '#1D1D1D',
        },
        title: {
            text: null
        },
        xAxis: {
            title: {
                text: null
            },
            type: 'datetime',
            tickInterval: 24 * 3600 * 1000,
            labels: {enabled:true, rotation: -45, align: 'right',formatter: function() {
                return Highcharts.dateFormat('%b %e', this.value);
              } }
        },
        yAxis: {
            min:0,
            gridLineWidth: 0.1,
            title: {
                text: '',
                align: 'high'
            }
        },
        tooltip: {
            useHTML: true,
            backgroundColor: "#363636",
            formatter: function () {
                return `<div><div>Install <br/></div><div style="text-align: center; font-size:15px; font-weight:800">${this.y}</div></div>`
            },
            style: {
                color: 'white',
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [{
            type:graphType,
            data: graphData
        }
        ]
      }

    return (
        <>
            <HighchartsReact
                id="container"
                highcharts={Highcharts}
                options={options}
            />
        </>
    )
}

export default AnalyticsChart;